// assets routes

const routes = [
  {
    path: "/assets",
    name: "AssetsHome",
    component: () => import("@/views/assets/AssetsHome.vue"),
    meta: { requiresAuth: true, app: "assets" },
  },
  {
    path: "/share/:token",
    name: "PublicAssetPage",
    component: () => import("@/views/assets/PublicAssetPage.vue"),
    meta: { public: true, standalone: true },
  },
];

export default routes;
